const SAFE_PROTOCOLS = ['http:', 'https:', 'mailto:'];
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

/**
 * Make a user-supplied URL safe to use as an href. React 18 renders `javascript:`
 * URLs as-is, so every link from user data must go through this.
 *
 * Bare domains ("example.com") become https URLs; anything that isn't http(s) or
 * mailto becomes '#'.
 */
export function safeUrl(raw) {
  if (typeof raw !== 'string') return '#';
  const value = raw.trim();
  if (!value) return '#';

  const candidate = HAS_SCHEME.test(value) ? value : `https://${value}`;
  try {
    const url = new URL(candidate);
    return SAFE_PROTOCOLS.includes(url.protocol) ? url.href : '#';
  } catch {
    return '#';
  }
}
